export const AUTOFILL = 'autofill';
export const LOAD_LINEUP = 'load-lineup';
export const PARTIAL_AUTOFILL = 'partial-autofill';
export const STANDARD = 'standard';
